import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { CmsmoduleService } from 'src/app/manage/cmsmodule/service/cmsmodule.service';
import { BannerService } from 'src/app/services/banner.service';
import { RoleService } from 'src/app/services/role.service';
@Component({
  selector: 'app-highlights',
  templateUrl: './highlights.component.html',
  styleUrls: ['./highlights.component.scss']
})
export class HighlightsComponent implements OnInit {
  params = {
    autoplay: 1,
    muted: 1,
    controls: 0,
  };
  onMessage(event: CustomEvent<any>) {
    const message = event.detail;
    // ...
  }
  public loading: boolean;
  public cmsContent;
  public cmsContentData;
  public errorMessage: string;
  public bannerList: any[];
  public totalRecords = 0;
  public showHighlightImg = "";
  items: MenuItem[];
  season5images: any[] | undefined;
  season4images: any[] | undefined;
  season3images: any[] | undefined;
  season2images: any[] | undefined;
  public bannerImageList: any[] = [];
  displayBasic: boolean | undefined;
  carouselResponsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 12,
      numScroll: 12,
      margin: 20,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 2,
      margin: 20,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  responsiveOptions: any[] = [
    {
      breakpoint: '1500px',
      numVisible: 5
    },
    {
      breakpoint: '1024px',
      numVisible: 3
    },
    {
      breakpoint: '768px',
      numVisible: 2
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];
  constructor(private cmsmoduleService: CmsmoduleService, private bannerService: BannerService,private roleService: RoleService, private router: Router) { }

  ngOnInit(): void { 
    this.roleService.setCurrentActiveRoute2(this.router.url);
    this.items = [
    {routerLink:"/", label: 'Home'},
    { label: 'Highlights'},
     ];
     this.getCmsContent();
     this.getBanner();
     this.season5images=[
      {src:'assets/img/news/news-artical/Republic World _ 18-Dec-2023.jpg', link: 'https://www.republicworld.com/sports/tennis/tennis-premier-league-bengaluru-sg-mavericks-crowned-champions-of-tpl-season-5/'},
      {src:'assets/img/news/news-artical/The Bridge _ 18-Dec-2023.jpg' , link: 'https://thebridge.in/tennis/tennis-premier-league-bengaluru-sg-mavericks-champions-season-5-45228'},
      {src:'assets/img/news/news-artical/The Hindu _ 18-Dec-2023.jpg', link: 'https://www.thehindu.com/sport/tennis/mavericks-outclass-wizards-to-be-crowned-champions-of-tpl/article67648337.ece' },
      {src:'assets/img/news/news-artical/Divya Bharat _ 17-Dec-2023.jpg', link: 'https://divya-bharat.com/bengaluru-sg-mavericks-crowned-champions-of-season-5-of-tennis-premier-league-news18/' },
      {src:'assets/img/news/news-artical/News 18 _ 17-Dec-2023 copy.jpg', link: 'https://www.news18.com/sports/bengaluru-sg-mavericks-crowned-champions-of-season-5-of-tennis-premier-league-8707670.html' },
      {src:'assets/img/news/news-artical/News Deal _ 17-Dec-2023 copy.jpg', link: 'https://newsdeal.in/article67648326-ece/' },
      {src:'assets/img/news/news-artical/News 18 _ 17-Dec-2023 copy.jpg', link: 'https://www.news18.com/sports/bengaluru-sg-mavericks-crowned-champions-of-season-5-of-tennis-premier-league-8707670.html' },
      {src:'assets/img/news/news-artical/IWM Buzz _ 16-Dec-2023.jpg', link: 'https://www.iwmbuzz.com/movies/celebrities-movies/tennis-premier-league-2023-rakul-preet-singh-caught-in-candid-moment-with-her-team-ahead-of-match-photos/2023/12/16' },
      {src:'assets/img/news/news-artical/NDTV _ 16-Dec-2023 copy.jpg', link: 'https://sports.ndtv.com/tennis/tennis-premier-league-bengaluru-punjab-bengal-delhi-enter-semifinals-4687327' },
      {src:'assets/img/news/news-artical/The Hindu _ 16-Dec-2023 .jpg', link: 'https://www.thehindu.com/sport/tennis/tennis-premier-league-bengaluru-mavericks-enters-semifinals/article67645661.ece' },
      {src:'assets/img/news/news-artical/Sports Mint Media _ 15-Dec-2023.jpg', link: 'https://sportsmintmedia.com/tennis-premier-league-strikes-collaboration-with-wol-energy-drink/' },
      {src:'assets/img/news/news-artical/The Hindu _ 15-Dec-2023.jpg', link: 'https://www.thehindu.com/sport/tennis/tennis-premier-league-ramkumar-puts-bengaluru-mavericks-on-top/article67642640.ece' },
      {src:'assets/img/news/news-artical/News 18 _ 14-Dec-2023.jpg', link: 'https://www.news18.com/sports/tennis-premier-league-season-5-bengaluru-sg-mavericks-punjab-patriots-hyderabad-strikers-and-mumbai-leon-army-get-wins-8703084.html' },
      {src:'assets/img/news/news-artical/The Asia News _ 14-Dec-2023.jpg', link: 'https://www.theasianews.net/news/274064680/day-2-of-tennis-premier-league-season-5-ends-after-host-of-thrilling-matches' },
      {src:'assets/img/news/news-artical/The Hindu _ 14-Dec-2023_.jpg', link: 'https://www.thehindu.com/sport/tennis/bengal-wizards-soars-to-the-top-in-the-tennis-premier-league/article67638854.ece' },
      {src:'assets/img/news/news-artical/The Hindu _ 14-Dec-2023__.jpg', link: 'https://www.thehindu.com/sport/tennis/article67635245.ece' },
      {src:'assets/img/news/news-artical/Punjab Live _ 12-Dec-2023.jpg', link: 'https://www.punjablive.news/news/tennis-premier-league-bengal-wizards-gujarat-panthers-lead-charts-at-end-of-day-120231212232235/' },
      {src:'assets/img/news/news-artical/Sports Keeda _ 12-Dec-2023.jpg', link: 'https://www.sportskeeda.com/tennis/3-players-watch-tennis-premier-league-2023-ft-sumit-nagal' },
      {src:'assets/img/news/news-artical/Sports Mint Media _ 12-Dec-2023.jpg', link: 'https://sportsmintmedia.com/everything-to-know-about-the-tennis-premier-league-2023/' },
      {src:'assets/img/news/news-artical/The Hindu _ 12-Dec-2023.jpg', link: 'https://www.thehindu.com/sport/tennis/dennis-novak-and-jeevan-nedunchezhiyan-get-it-right-for-delhi-binnys-brigade/article67631534.ece' },
      {src:'assets/img/news/news-artical/Sports Mint Media _ 12-Dec-2023 copy.jpg', link: 'https://sportsmintmedia.com/tpl-team-bengaluru-sg-mavericks-onboard-multiple-brands-as-associate-partners/' },
      {src:'assets/img/news/news-artical/The Bridge _ 11-Dec-2023_.jpg', link: 'https://thebridge.in/tennis/tennis-premier-league-season-5-returns-with-smash-45140' },
      {src:'assets/img/news/news-artical/The Hindu _ 10-Dec-2023.jpg', link: 'https://www.thehindu.com/sport/tennis/tennis-premier-league-2023-indian-tennis-sumit-nagal/article67624687.ece' },
      {src:'assets/img/news/news-artical/Sports Keeda _ 3-Dec-2023_.jpg', link: 'https://www.sportskeeda.com/tennis/news-quick-fast-paced-entertaining-rutuja-bhosale-feels-tennis-premier-league-great-way-popularise-tennis-india' },
      {src:'assets/img/news/news-artical/Sports Mint Media _ 12-Dec-2023.jpg', link: 'https://sportsmintmedia.com/tennis-premier-league-to-enhance-tennis-culture-and-aptitude-in-india-with-its-tpl-app/' },
      {src:'assets/img/news/news-artical/Dailyworld _ 21-Nov-2023.jpg', link: 'https://www.dailyworld.in/news-detail.php?seq=487966&amp;news=TPL-app-bolsters-tennis-ecosystem-in-India-through-unique-features' },
      {src:'assets/img/news/news-artical/Media Brief _ 21-Nov-2023.jpg', link: 'https://mediabrief.com/tennis-premier-league-app/' },
      {src:'assets/img/news/news-artical/The Hans India _ 21-Nov-2023.jpg', link: 'https://assets.thehansindia.com/sports/tennis/tpl-app-bolsters-tennis-ecosystem-in-india-through-unique-features-839419' },
      {src:'assets/img/news/news-artical/The News Room _ 21-Nov-2023.jpg', link: 'https://newsroomodisha.com/tpl-app-bolsters-tennis-ecosystem-in-india-through-unique-features/' },
      {src:'assets/img/news/news-artical/Indian Television _ 1-Nov-2023.jpg', link: 'https://indiantelevision.com/television/tv-channels/sports/season-five-of-tennis-premier-league-to-air-on-sony-sports-network-231101' },
      {src:'assets/img/news/news-artical/Zee News _ 1-Oct-2023_.jpg', link: 'https://zeenews.india.com/people/from-malaika-aroras-hot-avatar-in-black-to-taapsee-pannus-infectious-smile-heres-how-bollywood-stars-dazzled-at-tennis-premier-league-auction-2669559.html' },

      //old      {src:'assets/img/news/news-artical/Lokmat Times _ 22-Nov-2023.jpg', link: 'https://www.lokmattimes.com/tennis/tpl-app-bolsters-tennis-ecosystem-in-india-through-unique-features/' },
      {src:'assets/img/heighlight/season5/1.png'},
      {src:'assets/img/heighlight/season5/1 (1).png'},      
      {src:'assets/img/heighlight/season5/2 (1).png'},
      {src:'assets/img/heighlight/season5/2.png'},
      {src:'assets/img/heighlight/season5/3(1).png'},
      {src:'assets/img/heighlight/season5/3.png'},
      {src:'assets/img/heighlight/season5/4(1).png'},
      {src:'assets/img/heighlight/season5/4.png'},
      {src:'assets/img/heighlight/season5/5.png'},
      {src:'assets/img/heighlight/season5/6(1).png'},
      {src:'assets/img/heighlight/season5/6.png'},
      {src:'assets/img/heighlight/season5/7(1).png'},
      {src:'assets/img/heighlight/season5/7.png'},
      {src:'assets/img/heighlight/season5/8(1).png'},
      {src:'assets/img/heighlight/season5/8.png'},
      {src:'assets/img/heighlight/season5/9 (1).png'},
      {src:'assets/img/heighlight/season5/9.png'},
      {src:'assets/img/heighlight/season5/10(1).png'},
      {src:'assets/img/heighlight/season5/10.png'},
      {src:'assets/img/heighlight/season5/11(1).png'},
      {src:'assets/img/heighlight/season5/11.png'},
      {src:'assets/img/heighlight/season5/12(1).png'},
      {src:'assets/img/heighlight/season5/12.png'},
      {src:'assets/img/heighlight/season5/13(1).png'},
      {src:'assets/img/heighlight/season5/13.png'},
      {src:'assets/img/heighlight/season5/14 june.png'},
      {src:'assets/img/heighlight/season5/14(1).png'},
      {src:'assets/img/heighlight/season5/14.png'},
      {src:'assets/img/heighlight/season5/15(1).png'},
      {src:'assets/img/heighlight/season5/15.png'},
      {src:'assets/img/heighlight/season5/16.png'},
      {src:'assets/img/heighlight/season5/17.png'},
      {src:'assets/img/heighlight/season5/18.png'},
      {src:'assets/img/heighlight/season5/19.png'},
      {src:'assets/img/heighlight/season5/20.png'},
      {src:'assets/img/heighlight/season5/21.png'},
      {src:'assets/img/heighlight/season5/22.png'},
      {src:'assets/img/heighlight/season5/23.png'},
      {src:'assets/img/heighlight/season5/24.png'}];
    this.season4images=[{
      src:'assets/img/heighlight/4R2A4348-min-scaled.jpg'}];
    this.season3images=[{src:'assets/img/heighlight/4R2A8313-min-scaled.jpg'},
    {src:'assets/img/heighlight/4R2A4343-min-scaled.jpg'},
    {src:'assets/img/heighlight/4R2A3800-min-scaled.jpg'}];
    this.season2images=[{
      src:'assets/img/heighlight/season2/0E1A7917-min.jpg'},
    {src:'assets/img/heighlight/season2/0E1A7513-min.jpg'},
    {src:'assets/img/heighlight/season2/0E1A7410-min-scaled.jpg'},
    {src:'assets/img/heighlight/season2/0E1A7394-min-scaled.jpg'},
    {src:'assets/img/heighlight/season2/0E1A7297-min-scaled.jpg'},
    {src:'assets/img/heighlight/season2/0E1A2216-min.jpg'},
    {src:'assets/img/heighlight/season2/0E1A0742-min-scaled.jpg'},
    {src:'assets/img/heighlight/season2/0E1A0678-min.jpg'},];
  }

  getCmsContent() {
    var query = "?filterByDisable=false&filterByStatus=true&filterBySlug=whatistpl";
    this.cmsmoduleService.getContentDetails(query).subscribe(
      data => {
        this.loading = false;
        this.cmsContent = data.data.items[0];
        if (this.cmsContent != undefined) {
          this.cmsContentData = this.cmsContent['cmsDescription'];
        }
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }

  getBanner() {
    let query = "?filterByDisable=false&filterByStatus=true&filterBySlug=whatistpl";
    this.bannerService.getbannerList(query).subscribe(
      data => {
        this.loading = false;
        this.bannerList = data.data.items;
        this.totalRecords = data.data.totalCount;
        this.bannerList.forEach(element => {
          this.bannerImageList = element.banner_image;
        });
      },
      err => {
        this.errorMessage = err.error.message;
      });
  }  
  
  public openHightlightImage(highlight) {
    this.displayBasic = true
    this.showHighlightImg = highlight.src;
  }

  @HostListener('window:keyup.esc', ['$event']) w(e: KeyboardEvent) {
    this.displayBasic = false;
  }
}
